<template>
  <div id="app" class="app-root">
    <main class="app-main">
      <router-view />
    </main>
    <FooterView />
  </div>
</template>
<script>
import FooterView from "@/components/FooterView.vue";
export default {
  name: "App",
  components: {
    FooterView,
  },
  mounted() {
    if (this.$route.query.code) {
      window.code = this.$route.query.code;
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss">
.app-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 1680px;
  margin-left: auto;
  margin-right: auto;
  overflow-x: hidden;
}

.app-main {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}
</style>
